export const NEPAL_DESCRIPTION_LIST_REQUEST = "NEPAL_DESCRIPTION_LIST_REQUEST";
export const NEPAL_DESCRIPTION_LIST_SUCCESS = "NEPAL_DESCRIPTION_LIST_SUCCESS";
export const NEPAL_DESCRIPTION_LIST_FAIL = "NEPAL_DESCRIPTION_LIST_FAIL";

export const NEPAL_DESCRIPTION_UPDATE_REQUEST =
  "NEPAL_DESCRIPTION_UPDATE_REQUEST";
export const NEPAL_DESCRIPTION_UPDATE_SUCCESS =
  "NEPAL_DESCRIPTION_UPDATE_SUCCESS";
export const NEPAL_DESCRIPTION_UPDATE_FAIL = "NEPAL_DESCRIPTION_UPDATE_FAIL";
export const NEPAL_DESCRIPTION_UPDATE_RESET = "NEPAL_DESCRIPTION_UPDATE_RESET";
